__turbopack_context__.v({
  "card": "QuickInfoSection-module__b9l0zq__card",
  "cardAction": "QuickInfoSection-module__b9l0zq__cardAction",
  "cardLead": "QuickInfoSection-module__b9l0zq__cardLead",
  "cardText": "QuickInfoSection-module__b9l0zq__cardText",
  "cardTitle": "QuickInfoSection-module__b9l0zq__cardTitle",
  "container": "QuickInfoSection-module__b9l0zq__container",
  "icon": "QuickInfoSection-module__b9l0zq__icon",
  "section": "QuickInfoSection-module__b9l0zq__section",
});
